import { render, staticRenderFns } from "./DocumentLayoutCreate.vue?vue&type=template&id=1785a31d"
import script from "./DocumentLayoutCreate.vue?vue&type=script&lang=js"
export * from "./DocumentLayoutCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports